import React from "react";
import { RCCGrid } from "react-common-components";
import LovCategoriesOccurrences from "src/components/Lov/CategoriesOccurrences";
import LovOriginOccurrences from "src/components/Lov/OriginOccurrences";
import LovRequirementsOccurrences from "src/components/Lov/RequirementsOccurrences";
import { useTranslation } from "src/context/Translations/context";
import Title from "src/components/Title";
import LovTags from "src/components/Lov/Tags";
import { TagsTypes } from "src/components/FiltersTagsContainer/interface";
import Audit from "src/components/Audit";
import { ITabGeneralAudit } from "./interface";
import FormSimplifiedFields from "./formSimplifiedFields";

const TabGeneral : React.FC<ITabGeneralAudit> = ({
	audit,
	register,
	control,
	error, 
	isCopy,
	disabled,
	onChangeStandard
}) => {

	const { translate } = useTranslation();

	const defaultValue = (value: any, label: any) => {
		if(label && value)
			return { value: String(value), label};

		if(value)
			return value.toString();

		return "";
	};

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>
				<RCCGrid
					container
					item
					sm={8}
					xs={12}
					justifyContent="flex-end"
				>
					{
						audit.adb001CodigoInterno &&
						<Title color="purple" size="sm">
							{`${translate("Código")}: ${audit.adb001CodigoInterno}`}
						</Title>
					}

					<Audit data={audit} type="pop"/>
				</RCCGrid>

				<FormSimplifiedFields 
					control={control}
					isDisabled={disabled}
					isCopy={isCopy}
					error={error}
					register={register}
					audit={audit}
					onChangeStandard={onChangeStandard}
				/>

				<RCCGrid
					container
					item
					sm={8}
					xs={12}
				>
					<LovTags 
						control={control}
						name="adb001Tags"
						label={translate("Tags")}
						defaultValue={Array.isArray(audit.adb001Tags) ? audit.adb001Tags.join(", ") : audit.adb001Tags}
						disabled={disabled}
						extraParametersOnLoad={{
							use: TagsTypes.AUDITS
						}}
						extraParametersOnCreate={{
							use: TagsTypes.AUDITS
						}}
					/>
				</RCCGrid>

				{/* OCORRENCIAS */}
				<RCCGrid
					container
					item
				>
					<hr style={{marginTop:20}}/>
					<Title color="purple"
						size="sm"
					>
						{translate("Ocorrências")}
					</Title>
				</RCCGrid>
				<RCCGrid
					container
					item
					sm={8}
					xs={12}
				>
					<RCCGrid
						container
						item
					>
						<LovRequirementsOccurrences 
							control={control}
							name="adb001Oca001Id"
							label={translate("Requisito")}
							error={error.adb001Oca001Id}
							defaultValue={defaultValue(audit.adb001Oca001Id, audit.adb001Oca001Descricao)}
							disabled={disabled}
						/>
					</RCCGrid>
					<RCCGrid
						container
						item		
					>
						<LovOriginOccurrences 
							control={control}
							name="adb001Oca002Id"
							error={error.adb001Oca002Id}
							label={translate("Origem")}
							defaultValue={defaultValue(audit.adb001Oca002Id, audit.adb001Oca002Descricao)}
							disabled={disabled}
						/>
					</RCCGrid>
					<RCCGrid
						container
						item		
					>
						<LovCategoriesOccurrences 
							control={control}
							name="adb001Oca004IdNC"
							label={translate("Categoria de Não Conforme")}
							error={error.adb001Oca004IdNC}
							defaultValue={defaultValue(audit.adb001Oca004Idnc, audit.adb001Oca004DescricaoNC)}
							disabled={disabled}
						/>
					</RCCGrid>	
					<RCCGrid
						container
						item		
					>
						<LovCategoriesOccurrences 
							control={control}
							name="adb001Oca004IdOM"
							label={translate("Categoria de Oportunidade de Melhoria")}
							error={error.adb001Oca004IdOM}
							defaultValue={defaultValue(audit.adb001Oca004Idom, audit.adb001Oca004DescricaoOM)}
							disabled={disabled}
						/>
					</RCCGrid>	
					<RCCGrid
						container
						item		
					>
						<LovCategoriesOccurrences 
							control={control}
							name="adb001Oca004IdOB"
							label={translate("Categoria de Observação")}
							error={error.adb001Oca004IdOB}
							defaultValue={defaultValue(audit.adb001Oca004Idob, audit.adb001Oca004DescricaoOB)}
							disabled={disabled}
						/>
					</RCCGrid>	
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default TabGeneral;
